import escapeRegExp from "lodash/escapeRegExp";
import { type ComponentPropsWithoutRef, type ElementType, useMemo } from "react";

type Props<T extends ElementType> = {
  highlight: string;
  highlightClass?: string;
  children: string;
  as?: keyof JSX.IntrinsicElements;
} & ComponentPropsWithoutRef<T>;

export const TextWithHighlight = <T extends ElementType>({
  highlight,
  children,
  highlightClass = "f-info-color",
  as = "span",
  ...rest
}: Props<T>) => {
  const Tag = as;

  const parts = useMemo(() => {
    if (!highlight) {
      return [children];
    }
    const query = escapeRegExp(highlight.toLowerCase());
    return children.split(new RegExp(`(${query})`, "gi")).map((part, index) =>
      part.toLowerCase() === query ? (
        <span key={index} className={highlightClass}>
          {part}
        </span>
      ) : (
        part
      ),
    );
  }, [children, highlight]);

  return <Tag {...rest}>{parts}</Tag>;
};
